// Silence known noisy `console.warn` strings emitted by third-party
// libraries that bake in deprecated react-native-web style APIs (we
// can't fix the source). This file is imported as a side-effect at
// the very top of main.tsx so the filter is installed BEFORE any
// `import 'react-native-*'` runs — ES-module imports are hoisted, so
// putting the filter inline in main.tsx wouldn't catch warnings
// emitted during the import phase.
//
// Filtered prefixes:
//   - `"shadow*" style props are deprecated` — emitted by
//     react-native-toast-message at style-create time.
//   - `props.pointerEvents is deprecated` — any remaining
//     third-party tree that still uses the legacy prop.
//   - `Animated: useNativeDriver is not supported` — emitted by any
//     library that ships `useNativeDriver: true` and is loaded on
//     web. Our own code passes `Platform.OS !== 'web'` so this only
//     trips for dependencies we don't control.

const SILENCED_PREFIXES = [
  '"shadow*" style props are deprecated',
  'props.pointerEvents is deprecated',
  'Animated: `useNativeDriver` is not supported',
];

const originalWarn = console.warn.bind(console);
console.warn = (...args: unknown[]): void => {
  const first = args[0];
  if (typeof first === 'string' && SILENCED_PREFIXES.some((p) => first.startsWith(p))) {
    return;
  }
  originalWarn(...args);
};
